import { Toggle } from "shared/components";

export type MultipleChoiceQuestion = {
  label: string;
  value: string;
};

export interface MultipleChoiceQuestionProps {
  choices: Array<MultipleChoiceQuestion>;
  onChange?: (value: string) => void;
  subTitle?: string;
  title?: string;
  value: string;
}

export function MultipleChoiceQuestion({
  choices,
  onChange,
  subTitle,
  title,
  value,
}: MultipleChoiceQuestionProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <h2 className="text-textPrimary text-bodylg">{title}</h2>
        {subTitle && <p className="text-textSubdued text-bodymd">{subTitle}</p>}
      </div>

      <div className="flex gap-2">
        {choices.map((choice, index) => {
          return (
            <Toggle
              className="aria-invalid:border-redBorder"
              key={index}
              onClick={() => {
                if (value === choice.value) {
                  onChange?.("");
                } else {
                  onChange?.(choice.value);
                }
              }}
              pressed={value === choice.value}
              variant="rounded"
            >
              {choice.label}
            </Toggle>
          );
        })}
      </div>
    </div>
  );
}
